import React, { Component } from 'react';
import Navbar from './modules/Navbar';
import Hero from './modules/Hero';
import About from './modules/About';
import Theme from './modules/Theme';
import Prizes from './modules/Prizes';
import Judges from './modules/Judges';
import Timeline from './modules/Timeline';
import Training from './modules/Training';
import Gallery from './modules/Gallery';
import Video from './modules/Video';
import Register from './modules/Register';
import Partners from './modules/Partners';
import Faq from './modules/Faq';
import Contact from './modules/Contact';
import Footer from './modules/Footer';
import ScrollButton from './modules/ScrollButton';
import { Helmet } from "react-helmet";
import './scss/App.scss';

class Application extends React.Component {
  constructor(props){
    super(props);
    this.title = "National Data Science Challenge 2019 By Shopee";
    this.desc = "Join in Shopee’s National Data Science Challenge 2019 from 23 February to 30 March 2019! We invite students and professionals to join in the largest data science competition in Singapore. Champion team stand to win up to SGD 3000 in cash and full-time or internship opportunities at Shopee.";
    this.url = "https://careers.shopee.sg/ndsc";
    this.imageURL = "https://careers.shopee.sg/ndsc/images/ndsc_cover.png";
  }
  render() {
    return (
      <div className="application">
        <Helmet
          title={this.title}
          titleAttribute={{ itemprop: "name", lang: "en" }}
          meta={[
            { name: "author", content: "Ken Huang" },
            { name: "description", content: this.desc },
            { name: "robots", content: "index, follow" },
            { property: "og:title", content: this.title },
            { property: "og:site_name", content: this.title },
            { property: "og:type", content: "website" },
            { property: "og:url", content: this.url },
            { property: "og:image", content: this.imageURL },
            { property: "og:description", content: this.desc },
          ]}
          link={[
            { rel: "canonical", href: this.url },
          ]}
          script={[{
            type: "application/ld+json",
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Event",
              "name": this.title,
              "description": this.desc,
              "image": this.imageURL,
              "startDate": "2019-02-23T00:00+08:00",
              "endDate": "2019-03-30T23:59+08:00",
              "url": this.url,
              "Performer": "Shopee Singapore",
              "audience":{
                "@type": "EducationalAudience",
                "educationalRole": "Students and Professionals passionate about Data Science",
              },
              "location":{
                "@type": "Place",
                "name": "NTU",
                "address": "50 Nanyang Ave, Singapore 639798",
                "hasMap": "https://goo.gl/maps/3iTtkPVWDHS2",
              },
              "offers":{
                "@type": "Offer",
                "price": "3000",
                "url": this.url,
                "priceCurrency": "SGD",
                "availability": "http://schema.org/InStock",
                "validFrom": "2019-03-30",
              },
            })
          }]}
        />
      </div>
    );
  }
};

class App extends Component {
  render() {
    return (
      <div className="App">
        <Application />
        <Navbar />
        <ScrollButton scrollStepInPx="50" delayInMs="16.66"/>
        <Hero />
        <About />
        <Theme />
        <Prizes />
        <Judges />
        <Timeline />
        <Training />
        <Register />
        <Gallery />
        <Video />
        <Partners />
        <Faq />
        <Contact />
        <Footer />
      </div>
    );
  }
}

export default App;
